/* batida-v7-card.js (8.10.2026, Horizon P2/P5): what the product card (snippets/batida-v7-card) does in the browser.
   Two behaviours, both ported 1:1 from the live theme (b2c-redesign @ 3bad9e8):
   1. QUICK ADD (the cart icon next to "Wybierz"): live assets/batida-v7-clarity.js, block "Clarity 7.10 (Aleksandra 19:39)".
      The tap adds the product in the background (/cart/add.js), the icon shows a tick at once, the header counter goes up and a
      small bar "Dodano do koszyka · Zobacz koszyk" appears. If Shopify refuses (sold out, a required choice) the product page
      opens instead; on a network error the plain form post runs. Where the Batida cart drawer is loaded
      (window.__batidaDrawerLoaded, P4) it adds and opens itself - then only the tick + the Clarity event happen here
      (7.10: never a second add, "Tarta malinowa x2").
      Horizon: besides the live counter ([data-header-cart-count] + batida:cart-updated) the header's own cart bubble and
      theme:cart:change listeners are told through Horizon's shopify:cart:lines-update event (action "update": the Horizon
      drawer only auto-opens on "add", Batida keeps the toast).
   2. ZONE DIMMING: live assets/custom.js "v58 Global ZIP filter handler". The card carries <span data-batida-zone="A|AB">;
      from the visitor's delivery zone the card is greyed (.hidden_product / .hide_atc_info, CSS in batida-v7-card.css). The zone
      flags (window.hide_all_products / window.show_all_products) are set by the location gate of the header (zip-cookies, P1);
      until it exists nothing is greyed (= the live "browse" state).
   Stability (D9): the add has a 12 s deadline, failures fall back to the product page / plain form, nothing throws. */
(function () {
  'use strict';
  if (window.__batidaCardJs) return;
  window.__batidaCardJs = true;

  /* ---------- 1. quick add ---------- */
  var QA_T = ({
    pl: ['Dodano do koszyka', 'Zobacz koszyk', 'Dodaję…'],
    en: ['Added to basket', 'View basket', 'Adding…'],
    de: ['In den Warenkorb gelegt', 'Zum Warenkorb', 'Wird hinzugefügt…'],
    fr: ['Ajouté au panier', 'Voir le panier', 'Ajout…'],
    uk: ['Додано до кошика', 'Переглянути кошик', 'Додаю…']
  })[(document.documentElement.lang || 'pl').slice(0, 2)] || ['Dodano do koszyka', 'Zobacz koszyk', 'Dodaję…'];
  var QA_ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var qaBar = null, qaTimer = 0;

  function qaToast() {
    if (!qaBar) {
      qaBar = document.createElement('div');
      qaBar.className = 'v7cl-qa-bar';
      qaBar.setAttribute('role', 'status');
      qaBar.setAttribute('aria-live', 'polite');
      document.body.appendChild(qaBar);
    }
    qaBar.innerHTML = '<span>✓ ' + QA_T[0] + '</span><a href="' + QA_ROOT + 'cart?ref=dodano">' + QA_T[1] + ' →</a>';
    /* force a reflow so the slide-in plays when the bar already exists */
    void qaBar.offsetWidth;
    qaBar.classList.add('is-on');
    clearTimeout(qaTimer);
    qaTimer = setTimeout(function () { qaBar.classList.remove('is-on'); }, 5000);
  }

  /* P3 (9.10): the product page (assets/batida-pdp-runtime.js) shows the same bar after its add while the Batida drawer (P4) is not loaded */
  window.batidaCartToast = qaToast;

  function tellHorizon(cart) {
    try {
      var n = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
      var ev = new Event('shopify:cart:lines-update', { bubbles: true });
      ev.action = 'update';
      ev.promise = Promise.resolve({ cart: { totalQuantity: n }, detail: { itemCount: n, source: 'batida-quick-add' } });
      document.dispatchEvent(ev);
    } catch (e) { /* the counter below still works */ }
  }

  function qaCount() {
    var read = window.batidaCart && window.batidaCart.read
      ? window.batidaCart.read()
      : fetch(QA_ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    read.then(function (c) {
      document.querySelectorAll('[data-header-cart-count]').forEach(function (el) {
        el.setAttribute('data-header-cart-count', c.item_count);
        el.textContent = c.item_count;
      });
      tellHorizon(c);
      document.dispatchEvent(new CustomEvent('batida:cart-updated', { detail: c }));
    }).catch(function (e) { console.warn('[batida-card] cart read failed', e && e.message); });
  }

  function clarityEvent() { if (window.clarity) { try { window.clarity('event', 'quick_add'); } catch (x) {} } }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.classList || !f.classList.contains('v7-card__quick') || !window.fetch) return;
    var btn = f.querySelector('.v7-card__qbtn');
    if (window.__batidaDrawerLoaded) {
      if (btn) { btn.classList.add('is-added'); setTimeout(function () { btn.classList.remove('is-added'); }, 2500); }
      clarityEvent();
      return;
    }
    e.preventDefault();
    if (btn && btn.classList.contains('is-adding')) return;
    if (btn) { btn.classList.add('is-adding'); btn.setAttribute('aria-busy', 'true'); }
    var id = f.querySelector('input[name="id"]'), q = f.querySelector('input[name="quantity"]');
    var card = f.closest('.v7-card');
    var link = card && card.querySelector('a.v7-card__cta, a.v7-card__name');
    var ctl = window.AbortController ? new AbortController() : null;
    var tm = setTimeout(function () { try { if (ctl) ctl.abort(); } catch (x) {} }, 12000);
    fetch(QA_ROOT + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +(id && id.value), quantity: +(q && q.value) || 1 }] }),
      signal: ctl ? ctl.signal : undefined
    }).then(function (r) {
      clearTimeout(tm);
      if (btn) { btn.classList.remove('is-adding'); btn.removeAttribute('aria-busy'); }
      if (r.ok) {
        if (btn) { btn.classList.add('is-added'); setTimeout(function () { btn.classList.remove('is-added'); }, 2500); }
        qaToast(); qaCount(); clarityEvent();
      } else if (link) { location.href = link.href; } else { f.submit(); }
    }).catch(function () { clearTimeout(tm); if (btn) { btn.classList.remove('is-adding'); btn.removeAttribute('aria-busy'); } f.submit(); });
  }, true);

  /* a page restored from history (back/forward cache) must not keep a spinner */
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('.is-going, .v7-card__qbtn.is-adding').forEach(function (l) { l.classList.remove('is-going', 'is-adding'); });
  });

  /* ---------- 2. zone dimming ---------- */
  function applyZone(root) {
    var flagsKnown = typeof window.hide_all_products !== 'undefined' || typeof window.show_all_products !== 'undefined';
    if (!flagsKnown) return;
    var hideAll = window.hide_all_products === true, showAll = window.show_all_products === true;
    (root || document).querySelectorAll('.v7-card > [data-batida-zone]').forEach(function (marker) {
      if (marker.getAttribute('data-v58-applied') === '1') return;
      marker.setAttribute('data-v58-applied', '1');
      var card = marker.parentElement;
      if (!card || !card.classList) return;
      var zone = marker.getAttribute('data-batida-zone');
      if (hideAll) { card.classList.add('hide_atc_info'); return; }
      if (showAll) { card.classList.remove('hidden_product'); return; }
      if (zone === 'A') card.classList.add('hidden_product'); else card.classList.remove('hidden_product');
    });
  }
  function zoneInit() {
    applyZone();
    setTimeout(applyZone, 800);
    setTimeout(applyZone, 2500);
    try {
      var mo = new MutationObserver(function (muts) {
        if (muts.some(function (m) { return m.addedNodes && m.addedNodes.length; })) applyZone();
      });
      mo.observe(document.body, { childList: true, subtree: true });
    } catch (e) { /* the timers above still ran */ }
  }
  window.__batidaV58Filter = applyZone;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', zoneInit); else zoneInit();
})();
